﻿import {$$, get, initForm, postDataText} from "@/Utils";
import {CustomerSupportSubType} from "@/enums";
import {openPanel} from "@/sharedComponents/Panel";

function initCustomerServiceForm() {
    const callback = function (resp: Response) {
        return resp.text().then(text => {
            get("customer-service-panel").outerHTML = text;
            initCustomerServiceForm();
        });
    }
    initForm("customer-service-form", callback);
}

function initNotifyPageErrorForm() {
    const callback = function (resp: Response) {
        return resp.text().then(text => {
            get("notify-page-error-panel").outerHTML = text;
            initNotifyPageErrorForm();
        });
    }
    initForm("notify-page-error-form", callback);
}

function initContactHrForm() {
    const callback = function (resp: Response) {
        return resp.text().then(text => {
            get("contact-hr-panel").outerHTML = text;
            initContactHrForm();
        });
    }
    initForm("contact-hr-form", callback);
}

function initProductHelpButtons() {
    $$("[data-help-for-product]").forEach(x => {
        x.addDataBoundEventListener("click", function () {
            const productId = parseInt(x.getAttribute("data-help-for-product"));
            const invoiceNo = x.getAttribute("data-invoice-no");
            const data = {productId: productId, invoiceNo: invoiceNo, type: CustomerSupportSubType.NeedHelpUsingProduct}
            postDataText(window.config.productHelpFormUrl, data, fillPanelAndInitForm);
        });
    });
}

function initCustomerServiceSubTypeForm() {
    const callback = function (resp: Response) {
        return resp.text().then(text => {
            get("customer-support-type").innerHTML = text;
            initCustomerServiceSubTypeForm();
        });
    }
    initForm("customer-support-type-form", callback);
}

export function initCustomerService() {
    initCustomerServiceForm();
    initContactHrForm();
    initNotifyPageErrorForm();
    initCustomerServiceSubTypeForm();
    initProductHelpButtons();
}

export function fillPanelAndInitForm(data: string) {
    get("customer-support-type").innerHTML = data;
    initCustomerServiceSubTypeForm();
    openPanel("customer-support-type-panel");
}